import { render, staticRenderFns } from "./ClientsFormatter.vue?vue&type=template&id=5ec164dc&scoped=true"
import script from "./ClientsFormatter.vue?vue&type=script&lang=ts"
export * from "./ClientsFormatter.vue?vue&type=script&lang=ts"
import style0 from "./ClientsFormatter.vue?vue&type=style&index=0&id=5ec164dc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec164dc",
  null
  
)

export default component.exports